module.exports = __webpack_public_path__ + "img/SketchPng05dd9f342f3f60d662ade1f7c426538c7eec2b07f5e1dcf9c13f4facd6121b7d.324c1d69.png";